import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wrap"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-15" }
const _hoisted_4 = { class: "col-85" }
const _hoisted_5 = { class: "page-view" }
const _hoisted_6 = {
  key: 1,
  class: "page-wrap signed-out"
}
const _hoisted_7 = { class: "top-bar" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", null, "Sign In", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("input", {
  class: "btn",
  type: "submit",
  value: "Sign In"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationComponent = _resolveComponent("NavigationComponent")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.signedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_NavigationComponent)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_view)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.signedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "logo",
              src: this.logo
            }, null, 8, _hoisted_8)
          ]),
          _hoisted_9,
          _createElementVNode("form", {
            class: "sign-in",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.login()), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              id: "email",
              type: "email",
              name: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              placeholder: "Email Address"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              type: "password",
              name: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              placeholder: "Password"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ]),
            _hoisted_10
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}